<template>
	<div>
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>会员管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>预充值管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div style="margin-bottom: 20px;">
				<el-form ref="memberPremoneyPageInfoReq" :model="memberPremoneyPageInfoReq" label-width="80px" inline
					size="small">
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="memberPremoneyPageInfoReq.distributorId" placeholder="请选择" clearable
							style="width: 150px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号:">
						<el-input :clearable=true v-model="memberPremoneyPageInfoReq.memberMobile" placeholder="请输入手机号"
							style="width: 150px;" />
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="memberPremoneyPageInfoReq.status" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in statusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间:">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;margin-left: 8px;"
							@click="reGetMemberPremoneyList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 预付金列表区域 -->
			<el-table :data="memberPremoneyList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index"></el-table-column>
				<el-table-column label="手机号" prop="memberMobile"></el-table-column>
				<el-table-column label="预付金额" prop="preMoney">
					<template slot-scope="scope">
						<span style="color: #67C23A; font-weight: bold;">¥{{ scope.row.preMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="消费金额" prop="costMoney">
					<template slot-scope="scope">
						<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.costMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="已退款金额" prop="backMoney">
					<template slot-scope="scope">
						<span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.backMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="150px"></el-table-column>
				<el-table-column label="更新时间" prop="updateTime" width="150px"></el-table-column>
				<el-table-column label="运营商" prop="distributorId">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="120px">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.status === 0 ? 'success' : (scope.row.status === 1 ? 'primary' : (scope.row.status === 2 ? 'warning' : (scope.row.status === 3 ? 'success' : (scope.row.status === 4 ? 'danger' : 'info'))))">
							{{ getStatusDesc(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="150px" label="操作">
					<template slot-scope="scope">
						<el-button
							v-if="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 4 || scope.row.status === 5"
							size="mini" type="warning"
							@click="backMoney(scope.row.id, scope.row.memberMobile)">退款</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="memberPremoneyPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="memberPremoneyPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>

			<!-- 退款对话框 -->
			<el-dialog title="预付金退款" :visible.sync="backMoneyDialogVisible" width="500px">
				<el-form :model="backMoneyForm" label-width="100px">
					<el-form-item label="手机号:">
						<el-input v-model="backMoneyForm.memberMobile" disabled></el-input>
					</el-form-item>
					<el-form-item label="退款金额:">
						<el-input v-model="backMoneyForm.backMoney">
							<template slot="prepend">¥</template>
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="backMoneyDialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="confirmBackMoney">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			user: '',
			isAdmin: false,
			dateRange: [],
			distributorOptions: [],
			distributorInfoList: [], // 存储完整的运营商信息
			statusOptions: [{
				key: 0,
				value: '已退款'
			}, {
				key: 1,
				value: '未退款'
			}, {
				key: 2,
				value: '已消费'
			}, {
				key: 3,
				value: '消费已退款'
			}, {
				key: 4,
				value: '消费未退款'
			}, {
				key: 5,
				value: '执行退款中'
			}],
			memberPremoneyPageInfoReq: {
				//当前页数
				page: 1,
				//当前每页多少条
				limit: 8,
				memberId: '',
				memberMobile: '',
				status: '',
				distributorId: '',
				startDate: '',
				endDate: ''
			},
			memberPremoneyList: [],
			total: 0,
			backMoneyDialogVisible: false,
			// 批量操作相关数据
			multipleSelection: [],
			memberPremoneyInfo: {},
			backMoneyForm: {
				id: '',
				memberId: '',
				preMoney: '',
				reason: ''
			},
		}
	},
	created() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.getDistributorOptions();
		this.getMemberPremoneyList();
	},
	methods: {
		async getMemberPremoneyList() {
			const { data: res } = await this.$http.post(
				'/member/premoney/getMemberPremoneyPageInfo', this.memberPremoneyPageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.memberPremoneyList = res.data.list
			this.total = res.data.total
		},
		reGetMemberPremoneyList() {
			this.memberPremoneyPageInfoReq.page = 1;
			this.getMemberPremoneyList();
		},
		// 获取运营商选项
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				this.distributorInfoList = []; // 清空并重新赋值
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
				// 保存完整的运营商信息
				this.distributorInfoList = distributorInfoList;
			});
		},
		// 处理日期范围变化
		handleDateChange(val) {
			if (val) {
				this.memberPremoneyPageInfoReq.startDate = val[0];
				this.memberPremoneyPageInfoReq.endDate = val[1];
			} else {
				this.memberPremoneyPageInfoReq.startDate = '';
				this.memberPremoneyPageInfoReq.endDate = '';
			}
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.memberPremoneyPageInfoReq.limit = pageSize
			this.getMemberPremoneyList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.memberPremoneyPageInfoReq.page = pageNum
			this.getMemberPremoneyList()
		},
		// 退款操作
		backMoney(id, memberMobile) {
			// 获取预付金详情
			this.$http.get('/member/premoney/getMemberPremoneyById/' + id).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				const data = res.data;
				this.backMoneyForm = {
					id: id,
					memberMobile: memberMobile,
					backMoney: data.preMoney,
					reason: ''
				};
				this.backMoneyDialogVisible = true;
			});
		},
		// 确认退款
		confirmBackMoney() {
			this.$confirm('确认退款 ¥' + this.backMoneyForm.backMoney + ' 吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/member/premoney/backMoneyWithAmount', {
					id: this.backMoneyForm.id,
					type: 1, // 默认类型为1
					refundAmount: this.backMoneyForm.backMoney
				}).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.backMoneyDialogVisible = false;
					this.reGetMemberPremoneyList();
					this.$message.success(res.data.msg);
				})
			}).catch(() => {
				this.$message.info('已取消退款');
			});
		},
		// 监听多选框变化
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 获取状态描述
		getStatusDesc(status) {
			switch (status) {
				case 0:
					return '已退款';
				case 1:
					return '未退款';
				case 2:
					return '已消费';
				case 3:
					return '消费已退款';
				case 4:
					return '消费未退款';
				case 5:
					return '执行退款中';
				default:
					return '未知状态';
			}
		},
		// 根据ID获取运营商名称
		getDistributorName(distributorId) {
			if (!distributorId) return '未知';
			const distributor = this.distributorInfoList.find(item => item.id === distributorId);
			return distributor ? distributor.name : '未知';
		},
	}
}
</script>

<style scoped>
.el-breadcrumb {
	margin-bottom: 15px;
	font-size: 12px;
}

.el-card {
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.el-table {
	margin-top: 15px;
	font-size: 12px;
}

.el-pagination {
	margin-top: 15px;
}
</style>